module.exports = __webpack_public_path__ + "img/share_img_top@2x.9f3d91d0.png";